import SliderImg1 from '@/assets/img/pictures/slide-img-1.png';
import SliderImg3 from '@/assets/img/pictures/slide-img-5.png';
import SliderImg5 from '@/assets/img/pictures/slide-img-7.png';
import SliderImg6 from '@/assets/img/pictures/slide-img-8.png';

export const slides = [
  {
    imgUrl: SliderImg1,
    testimony:
      'I started using Mima to manage my business 3 months ago, the payroll system has made it easier for me to pay my workers and monitor what costs actually take more of my business capital.',
    name: 'Chika Uluocha',
    business: 'Rovers Consultancy Limited',
    title: 'My Payroll made easier',
  },
  {
    imgUrl: SliderImg3,
    testimony:
      'Using Mima has been one of the best things I did for my business this year. The business account, invoice and receipt feature is my favorite because it makes my brand more professional and serious. I can even do a money transfer through the app…..mind blowing!!',
    name: 'Ohen Michael',
    business: 'CEO St. Michael beauty',
    title: 'Simplified Business Accounting',
  },
  {
    imgUrl: SliderImg5,
    testimony:
      'Mima is a Business Management Application that acts as a virtual assistant to SMEs, I particularly love the fact that I am able to delegate certain parts Critical operations such as Financial Control and Customer Service to my staff with the privilege of Limiting access to these rights.',
    name: 'Zainab Oduniyi',
    business: 'Toshowoods',
    title: 'Simple for operations',
  },
  {
    imgUrl: SliderImg6,
    testimony:
      "I recently downloaded the Mima app and it's way above my expectations. So far, I've been enjoying the app. It's very swift, the interface is very easy to maneuver, and my best feature on it is being able to store my clients details in a database. With that I'm able to keep track of my clients and my sales. Can't wait for more features to be unlocked. I'll be rating it a solid 8/10",
    name: 'Olaitan',
    business: 'CEO of Phase Designs',
    title: 'Easy to Use',
  },
];
